import { render, staticRenderFns } from "./Modelselector.vue?vue&type=template&id=3dc14904&scoped=true"
import script from "./Modelselector.vue?vue&type=script&scoped=true&lang=js"
export * from "./Modelselector.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./Modelselector.vue?vue&type=style&index=0&id=3dc14904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc14904",
  null
  
)

export default component.exports